import axios from "axios";

const init = () => {
	const cookieNotice = document.querySelector('.cookie-notice');
	if (cookieNotice !== null) {
		const cookieNoticeClose = cookieNotice.querySelector('button');
		cookieNoticeClose.addEventListener('click', (e) => {
			
			// Do ajax call to set cookie
			axios.get('/close-cookie-notice');

			// Remove notice
			cookieNotice.remove();
		});
	}
}

export default init;